import { useQuery } from "react-query";
import Axios from "../../../configs/axios/axios-base.config";

export const useGetWaitingCollectRequests = () => {
	return useQuery(
		["waitingCollectingRequests"],
		() => {
			return Axios.get("users/getWaitingRequest").then((res) => res.data);
		},
		{
			refetchOnWindowFocus: false,
		}
	);
};
